import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="reload"
// Used in: student show page
// Purpose: reload page on create subscription
export default class extends Controller {
  initialize() {
    window.location.reload();
  }
}
